export const ACTIVITY = 'ACTIVITY'
export const LESSON = 'LESSON'
export const ASSESSMENT = 'ASSESSMENT'
export const TEMPLATE = 'TEMPLATE'
export const TEACHING_TOOL = 'TEACHING TOOL'
export const CLASSROOM_TOOLS = 'CLASSROOM_TOOLS'

export const ACTIVITIES = 'Activities'
export const LESSONS = 'Lessons'
export const ASSESSMENTS = 'Assessments'
export const TEMPLATES = 'Templates'
export const TEACHER_TOOLS = 'Teacher Tools'
export const CONTENT_TYPE_TITLE = 'Resource Type'
